import isDate from "./date/check";

/* eslint-disable react/display-name */
export function getAge({ constructedOn }: { constructedOn?: Date }): string {
	if (!constructedOn || !isDate(constructedOn)) return "";

	const now = new Date();
	const diffInYears = (now.getTime() - constructedOn.getTime()) / (86400000 * 365);
	const completedYears = Math.floor(diffInYears);

	if (diffInYears < -3) {
		return `Ready in ${Math.floor(-diffInYears)} Years`;
	} else if (diffInYears < 0) {
		return `Ready in ${Math.floor(-diffInYears * 12)} Months`;
	} else if (diffInYears < 1) {
		return "Just Ready To Move";
	} else if (completedYears === 1) {
		return `${completedYears} Year`;
	}
	return `${completedYears} Years`;
}
